import React, { Component } from "react";
import { bool, string, func } from 'prop-types';
import Header from "Orgs/Header";
import PageHeader from "Molecules/PageHeader";
import LoginForm from './children/LoginForm';
import SupportInfo from "Molecules/SupportInfo";
import Footer from "Orgs/Footer";
import TermsOfUseFooter from "Orgs/TermsOfUseFooter";
import { digitalData } from "../../../../utils/analyticsData";
import "react-client-captcha/dist/index.css";

let CAPTCHA;
if(sessionStorage.getItem('app_info')){
	CAPTCHA = JSON.parse(sessionStorage.getItem('app_info')).CAPTCHA;
} else {
	CAPTCHA="YES"
}

export default class LoginPage extends Component {
	constructor(props){
		super(props)
		this.state = {
			error: false,
			message: "",
			loginInfo:false,
			supportInfo:false,
			mobileView:false
		}
	}

	
	componentWillMount(){

		this.removeSessionStorage()

		if (!window.console) { window.console = {}; window.console.log = function () { } };
		//clear redux store if not cleared already
			this.props.resetStore();
			this.props.hidePayVeil();
			this.props.hidePayModal();
	}

	closeInfoBox = () =>{
		this.setState({
			...this.state,
			loginInfo:false,
			supportInfo:false
		});
	}

	componentDidMount(){
		try{
			const title=document.getElementsByTagName('title')[0];
			title.textContent="AIG Express Billing Payment";
			global.digitalData = digitalData;
			window.addEventListener("resize", () => {
				if (window.innerWidth < 760) {
					this.closeInfoBox();
				}
			});
		} catch (err) {}

	}

	removeSessionStorage = () => {
		localStorage.removeItem('recieptInfo');
	}

	errorMessagesHandler = (accountInfoCreds,accountNumber,zip) =>{
		if((typeof accountInfoCreds !== "object") || (accountNumber.length < 14 && zip.length < 5)){
			this.setState({
				error: true,
				message: "Something seems amiss with both of these entries. Please take a look at each field, and try again, thanks!"
			})
		} else if(accountNumber.length < 14 && zip.length === 5){
			this.setState({
				error: true,
				message: "Sorry, this Billing Account Number is invalid. Please input a 13-digit number."
			})
		} else if(accountNumber.length === 14 && zip.length < 5){
			this.setState({
				error: true,
				message: "Sorry, this U.S. Billing Zip Code doesn’t seem to be working."
			})
		}
	}

	submitHandler = (accountInfoCreds) => {
		let { accountNumber, zip, cCode } = accountInfoCreds
		// if(captcha)
		let user_captcha = '';
		if(CAPTCHA==="YES"){
			try{
				user_captcha=document.getElementById('user_captcha_input').value;
			} catch(err) {
				user_captcha=''
			}

		}

		if (accountInfoCreds.accountNumber && accountInfoCreds.zip && accountInfoCreds.accountNumber.length === 14 && accountInfoCreds.zip.length === 5) 
		{
			if (CAPTCHA==="NO" || user_captcha===cCode) {
				this.props.loadAccounts(accountInfoCreds.accountNumber, accountInfoCreds.zip, this.props.history)
			}
			else if(user_captcha === ''){
				this.setState({
					error: true,
					message: "Please provide captcha to continue!"
					})
				if(document.getElementById('user_captcha_input'))
					document.getElementById('user_captcha_input').value = "";
				
			}else {
				this.setState({
					error: true,
					message: "You have entered incorrect captcha! Please try again!!"
					})
				document.getElementById('user_captcha_input').value = "";
			}
		} else {
			this.errorMessagesHandler(accountInfoCreds,accountNumber,zip);
			
		}
	};

	

	componentWillReceiveProps(nextProps){
		if(nextProps.accountsInfo.error){
			this.setState({
				error: nextProps.accountsInfo.error,
				message: nextProps.accountsInfo.errorInfo.message
			})
			global.digitalData.page.error[0] = nextProps.accountsInfo.errorInfo.message
		}
	}

	toggleSupportInfo = () =>{
		let si=!this.state.supportInfo;
		this.setState({
			...this.state,
			loginInfo:false,
			supportInfo:si
		});
	}
	toggleLoginInfo = () =>{
		let li=!this.state.loginInfo;
		this.setState({
			...this.state,
			loginInfo:li,
			supportInfo:false,
		});
	}

	render() {
		let { error, message } = this.state;
		
		return (
			<div className="LoginPage">
				<div className="login-main">
					<Header toggleBox={this.toggleSupportInfo} closeBox={this.closeInfoBox}/>
					{this.state.supportInfo && <div aria-modal="true" className="infoBox support-info-is-visible">
						<SupportInfo closeBox={this.toggleSupportInfo}/>
					</div>}
					<div className="site-main">
						<PageHeader
							title="AIG Private Client Group"
							subtitle="Let's find your account."
						/>
						<main>
						<LoginForm
							loginInfo={this.state.loginInfo}
							toggleBox={this.toggleLoginInfo}
							error={error}
							errorMessage={message}
							submitHandler={this.submitHandler}
							billingAccountLength={14}
							zipCodeLength={5}
						/>
						</main>
					</div>
					<Footer mobile={true}/>
				</div>
					<TermsOfUseFooter/>

					{window.innerWidth<760 && <div className="infoBox support-info-is-hidden">
					<SupportInfo mobile={true}/>
					</div>}
				<div id="sdsfd" />
			</div>
		);
	}
}

LoginPage.propTypes = {
	error: bool,
	message: string,
	submitHandler: func
}



// WEBPACK FOOTER //
// ./src/components/atomic/pages/LoginPage/LoginPage.js